module.exports = __webpack_public_path__ + "1e05fb85fd1451cd5b954240c83121ac.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-110@2x.png
// module id = 495
// module chunks = 0